<template>
  <!-- Contact Us Section Start -->
  <section class="contact_page_section">
    <div class="container">
      <div class="contact_inner">
        <div class="contact_form">
          <div class="section_title">
            <h2>Leave a <span>message</span></h2>
            <p>Fill up form below, our team will get back soon</p>
          </div>
          <form action="#">
            <div class="form-group">
              <input
                type="text"
                placeholder="Name"
                class="form-control"
                id="name"
                required
                v-model="state.vu_name"
                v-bind:class="{
                  invaliddata: v$.vu_name.$error == true,
                }"
              />
              <span v-if="v$.vu_name.$error">
                {{ v$.vu_name.$errors[0].$message }}
              </span>
            </div>
            <div class="form-group">
              <input
                type="email"
                placeholder="Email"
                class="form-control"
                id="email"
                required
                v-model="state.vu_email"
                v-bind:class="{
                  invaliddata: v$.vu_email.$error == true,
                }"
              />
              <span v-if="v$.vu_email.$error">
                {{ v$.vu_email.$errors[0].$message }}
              </span>
            </div>

            <div class="form-group">
              <input
                placeholder="Phone"
                class="form-control"
                type="tel"
                id="phone"
                required
                v-model="state.vu_phone"
                v-bind:class="{
                  invaliddata: v$.vu_phone.$error == true,
                }"
              />
              <span v-if="v$.vu_phone.$error">
                {{ v$.vu_phone.$errors[0].$message }}
              </span>
            </div>
            <div class="form-group">
              <input
                type="text"
                placeholder="Subject"
                class="form-control"
                id="subject"
                required
                v-model="state.vu_subject"
                v-bind:class="{
                  invaliddata: v$.vu_subject.$error == true,
                }"
              />
              <span v-if="v$.vu_subject.$error">
                {{ v$.vu_subject.$errors[0].$message }}
              </span>
            </div>
            <div class="form-group">
              <textarea
                class="form-control"
                placeholder="Your message"
                id="message"
                cols="30"
                rows="6"
                required
              ></textarea>
            </div>

            <div class="form-group mb-0">
              <button type="submit" class="btn puprple_btn" @click="submitForm">
                SEND MESSAGE
              </button>
            </div>
          </form>
        </div>
        <div class="contact_info">
          <div class="icon">
            <img src="images/contact_message_icon.png" alt="image" />
          </div>
          <div class="section_title">
            <h2>Have any <span>question?</span></h2>
            <p>
              If you have any question about our product, service, payment or
              company, please leave a meesage to us.
            </p>
          </div>

          <ul class="contact_info_list">
            <li>
              <div class="img">
                <img src="images/mail_icon.png" alt="image" />
              </div>
              <div class="text">
                <span>Email Us</span>
                <a href="mailto:example@gmail.com">example@gmail.com</a>
              </div>
            </li>
            <li>
              <div class="img">
                <img src="images/call_icon.png" alt="image" />
              </div>
              <div class="text">
                <span>Call Us</span>
                <a href="tel:+1(888)553-46-11">+1 (888) 553-46-11</a>
              </div>
            </li>
            <li>
              <div class="img">
                <img src="images/location_icon.png" alt="image" />
              </div>
              <div class="text">
                <span>Visit Us</span>
                <p>5687, Business Avenue, New York, USA 5687</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Us Section End -->
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { reactive, computed } from "vue";
import { required, minLength, email } from "@vuelidate/validators";
export default {
  name: "ContactSection",

  setup() {
    const state = reactive({
      vu_name: "",
      vu_email: "",
      vu_phone: "",
      vu_subject: "",
    });

    const rules = computed(() => {
      return {
        vu_name: { required, minLength: minLength(3) },
        vu_email: { required, email },
        vu_phone: { required },
        vu_subject: { required },
      };
    });

    const v$ = useVuelidate(rules, state);
    return {
      state,
      v$,
    };
  },
  methods: {
    submitForm() {
      try {
        console.log("Hi");
        this.v$.$validate();

        if (!this.v$.$error) {
          this.sendEmail();
        }
      } catch (error) {
        console.log("Donetttttt");
        console.log(error);
        alert("form failed validation");
      }
    },
    sendEmail() {
      window.scroll(0, 0);
      // this.$router.push("/");
      history.pushState({}, "", "/thank-you");
    },
  },
};
</script>

<style scoped>
.contact_page_section .contact_inner {
  margin-top: 30px !important;
}
.form-group span {
  color: red;
}
.contact_page_section
  .contact_inner
  .contact_form
  form
  .form-group
  .form-control:focus {
  box-shadow: none;
  border-color: #dc481e;
  color: var(--purple);
}
</style>
